<style lang="scss">
.monitorAlertTable .el-progress-bar__outer {
  background: #606672;
}

.monitorAlertTable .el-progress__text {
  color: #ffffff;
}

.monitorAlertTable::before {
  z-index: inherit;
}

.monitorAlertTable.el-table {
  background-color: transparent;
}

.monitorAlertTable.el-table--border:after,
.monitorAlertTable.el-table--group:after,
.monitorAlertTable.el-table:before {
  background-color: transparent;
}

.monitorAlertTable.el-table tr {
  background-color: transparent;
}

.monitorAlertTable.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #33333a !important;
}

.monitorAlertTable .el-table td.gutter,
.monitorAlertTable.el-table th.gutter {
  background: #33333a;
}

.monitorAlertTable .el-table__body-wrapper {
  background: #1d1d24;
}

// 滚动条的宽度
.monitorAlertTable .el-table__body-wrapper::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

// 滚动条的滑块
.monitorAlertTable .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

/*滚动条里面轨道*/
// .monitorAlertTable .el-table__body-wrapper::-webkit-scrollbar-track {
// 	border-radius: 2px;
// 	background: #1D1D24;
// }
</style>
<style lang="scss" scoped="scoped">
.cell-class-name {
  border-bottom: 1px solid red !important;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
    <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
      <div style="display: flex;align-items: center;">
        <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
        <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
          {{ $t('baojingxinxi') }}
        </p>
      </div>
    </div>
    <div :style="{ height: contentHeight + 'px' }">
      <el-table ref="table" class="monitorAlertTable" :data="alerts" style="width: 100%" :max-height="contentHeight" :row-style="{ background: '#1D1D24', height: rowHeight + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: '#202027', color: '#FFFFFF', 'font-size': '14px' }" :header-cell-style="{ background: '#33333A', color: '#C0C4CC', padding: '0px', height: '42px', borderColor: '#33333A' }" cell-class-name="cell-class-name">
        <el-table-column prop="name" :label="$t('shebeimingcheng')"> </el-table-column>
        <el-table-column :label="$t('baojingxinxi')">
          <template slot-scope="scope">
            {{ $t(scope.row.i18n) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('kaishishijian')">
          <template slot-scope="scope">
            {{ dayjs.unix(scope.row.begin / 1000).format('MM-DD HH:mm') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('jieshushijian')">
          <template slot-scope="scope">
            {{ scope.row.end && dayjs.unix(scope.row.end / 1000).format('MM-DD HH:mm') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('chixushijian') + '(min)'">
          <template slot-scope="scope">
            {{ scope.row.end && ((scope.row.end - scope.row.begin) / 1000 / 60).toFixed(1) }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_efficiency_alert',
  components: {},
  watch: {
    '$attrs.shift'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listAlarm();
    },
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listAlarm();
    }
  },
  data() {
    return {
      interval: null,
      timer: null,
      contentHeight: 0,
      rowHeight: 0,
      alerts: [],
      isStopListScroll: false
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listAlarm();
    }, 120000);
    this.listAlarm();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.setAutoScroll();
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listAlarm() {
      let response = await this.http.get('/web/equipment/listShiftAlarm', {
        params: {
          orgId: this.$attrs.orgId
        }
      });
      this.alerts = response.data;
    },
    setAutoScroll() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      const listDiv = this.$refs.table.bodyWrapper;
      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
            this.isStopListScroll = true;
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
      }, 100);
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
        this.rowHeight = (this.contentHeight - 42 - 5) / 8;
      }, 800);
    }
  }
};
</script>
